import { Skeleton } from "@src/components";
import { EnrichedWalletToken } from "@src/models";
import { abbreviateNumber } from "@src/utils";
import { useMemo } from "react";
import { usePnL } from "../hooks/usePnL";

type Props = {
  yourTokens: EnrichedWalletToken[];
  yourCash: EnrichedWalletToken[];
  isLoading: boolean;
};

export const TotalValueCard = ({ yourTokens, yourCash, isLoading }: Props) => {
  const pnlData = usePnL();
  const totalValue = useMemo(() => {
    const cashSum = yourCash.reduce((sum, t) => sum + t.value, 0);
    const tokenSum = yourTokens.reduce((sum, t) => sum + t.value, 0);
    return cashSum + tokenSum;
  }, [yourCash, yourTokens]);

  const renderPnL = (percentageChange: number) => {
    const isPositive = percentageChange >= 0;
    return (
      <div
        className={`text-sm font-medium ${
          isPositive ? "text-success_color" : "text-error_color"
        }`}
      >
        {`${isPositive ? "+" : "-"} ${Math.abs(percentageChange).toFixed(2)}%`}
      </div>
    );
  };

  return (
    <div className="px-4 py-3 flex flex-col items-center justify-between rounded-[12px] bg-card_bg">
      <div className="text-sm font-medium text-text_primary text-opacity-60">
        Total
      </div>
      {isLoading ? (
        <Skeleton className="w-32 h-8" />
      ) : (
        <div className="flex flex-col items-center">
          <div className="text-2xl font-bold text-text_primary">
            ${abbreviateNumber(totalValue, 2, true)}
          </div>
          {pnlData?.totalAllTimePnLPercent !== undefined && (
            <div className="flex gap-2 items-center">
              <div className="flex justify-center">
                {renderPnL(pnlData.totalAllTimePnLPercent)}
              </div>
              <div className="text-sm font-medium text-text_primary text-opacity-60">
                All time
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
